import {useEffect, useState} from "react"
import {default as cx} from "classnames"

import {getLocaleDate} from "../../utilities/general"
import ValueFromApiRow from "../ValueFromApiRow"

export const WeekDetailsNHSRs = ({week, nhsrs}) => {
    const [nhsr, setNhsr] = useState(nhsrs[0] || {})
    useEffect(() => {
        setNhsr(nhsrs[0] || {})
    }, [week])

    return (
        <div className="card mb-4 ms-4 border border-gray-400">
            <div className="card-header p-4">
                <h3 className="card-title fw-bold">Week {week} NHSR submissions</h3>
            </div>
            <div className="card-body px-5">
                <div className="row px-4">
                    <ul className="nav nav-tabs flex-nowrap text-nowrap border-0 gap-2 mb-4" role="tablist">
                        {nhsrs.map((report) => {
                            return (
                                <li className="nav-item " role="presentation" key={report.response_id}>
                                    <button
                                        className={cx(
                                            "btn btn-flex btn-active-primary btn-active-color-light btn-light-primary fw-bold",
                                            {active: nhsr.response_id === report.response_id}
                                        )}
                                        onClick={() => setNhsr(report)}
                                    >
                                        {getLocaleDate(report.shift_date)}
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <div className="container">
                    {nhsr &&
                        nhsr.answers &&
                        nhsr.answers.map((answer) => {
                            return (
                                <span key={answer.question_order}>
                                    <div className="d-flex flex-row align-items-center fs-5 gap-4">
                                        <div className="d-flex flex-column">
                                            <div className="symbol symbol-30px me-2">
                                                <div className="symbol-label fs-5 fw-semibold bg-primary text-inverse-danger">
                                                    {answer.question_order}
                                                </div>
                                            </div>
                                        </div>
                                        {[1, 8, 12, 13].includes(answer.question_type_id) && (
                                            <div className="d-flex flex-row w-100 fs-5 gap-4">
                                                <div className="flex-grow-1 fw-bold">{answer.question_text}</div>
                                                <div className="d-flex  align-items-center">
                                                    <div className="rating">
                                                        {Array.from({length: answer.max_answer_value}, (_, i) => (
                                                            <div
                                                                key={i}
                                                                className={cx("rating-label me-1", {
                                                                    checked: answer.answer >= i + 1,
                                                                })}
                                                            >
                                                                <i className="fas fa-square fs-3"></i>
                                                            </div>
                                                        ))}
                                                        <div className="ms-1 fw-bold fs-4">{answer.answer}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {answer.question_type_id === 3 && (
                                            <span className="d-flex flex-column pt-1">
                                                <div className="d-flex flex-row fw-bold">{answer.question_text}</div>
                                                <div className="d-flex flex-row mt-2">{answer.answer}</div>
                                            </span>
                                        )}
                                        {answer.question_type_id === 9 && (
                                            <ValueFromApiRow
                                                stmt={answer.question_text}
                                                value={answer.answer}
                                                apiPath={answer.api_path}
                                            />
                                        )}
                                        {answer.question_type_id === 6 && (
                                            <div className="d-flex flex-row w-100 fs-5 gap-4">
                                                <div className="d-flex flex-row fw-bold">{answer.question_text}</div>
                                                <div
                                                    className={cx(
                                                        "badge badge-lg",
                                                        answer.answer === "Yes" ? "badge-success" : "badge-danger"
                                                    )}
                                                >
                                                    {answer.answer}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="separator border-1 border-secondary my-5"></div>
                                </span>
                            )
                        })}
                </div>
            </div>
        </div>
    )
}
